module.exports = require('./helpers/bundle-url').getBundleURL('kmvYf') + "juergen-kriz.eecfbafa.jpg" + "?" + Date.now();